import React, { useState } from 'react';
import styles from "../Footer/Footer.module.css";
import {Link} from "react-router-dom";
import Payments from 'assets/images/payments-img.png';
import { Trans, useTranslation } from 'react-i18next';
import { useLang } from 'hooks/useLang';
import CookiePopup from 'components/CookiePopup/CookiePopup';

const Footer = () => {
  const { t } = useTranslation();
  const { lang } = useLang();

type NavItem =
  | { label: string; path: string }   
  | { label: string; action: 'open-cookie-popup' };   

const navLinks = t('footer.navLinks', { returnObjects: true }) as NavItem[];

const [showCookie, setShowCookie] = useState(false);

    return (
    <footer className={styles.footer}>
    <div className={styles['footer-contacts']}>
        <ul className={styles['footer-list']}>
            <li className={`${styles['footer-item']} ${styles['footer-requisites']}`}>
                <Trans i18nKey="footer.legalInfo" components={{ bold: <strong />, br: <br /> }} />
            </li>
            <li className={`${styles['footer-item']} ${styles['work-time']}`}>{t('footer.workTime')}</li>
            <li className={`${styles['footer-item']} ${styles.phone}`}>
                <a href="tel:+375447804820">+375 (44)7804820</a>
            </li>
            <li className={`${styles['footer-item']} ${styles.mail}`}>
                <a href="mailto:vetbs82@kizombaseym.com">Vetbs7@mail.ru</a>
            </li>
        </ul>
    </div>
    <div className={styles['footer-info-block']}>
        <nav className={styles['footer-link']}>
            <ul className={styles['footer-navigation-list']}>
            {navLinks.map((link, index) => (
                <li key={index}> 
                {'path' in link ? (
                <Link to={`/${lang}${link.path}`}>{link.label}</Link>
                    ) : (
                <button type="button" className={styles.linkButton} onClick={() => setShowCookie(true)}>
                    {link.label}
                </button>
                )}
                </li>
            ))}
            </ul>
        </nav>
        <p className={styles['footer-copy']}>&copy; {t('footer.copyright')}</p>
        <div className={styles['footer-socials']}>
            <ul className={styles['footer-socials-list']}>
                <li>
                    <a href="https://t.me/Vital_KizzAI" className={`${styles.socialIcon} ${styles.telegramIcon}`}/>
                </li>
                <li>
                    <a href="https://vk.com/kizomba_seym" className={`${styles.socialIcon} ${styles.vkontakteIcon}`}/>
                </li>
                <li>
                    <a href="https://www.instagram.com/kizomba_seym?igsh=MXB4NHg0aGFmdzhpdw==" className={`${styles.socialIcon} ${styles.instagramIcon}`}/>
                </li>
                <li>
                    <a href="https://www.facebook.com/share/1FkyS9CpLh/?mibextid=wwXIfr" className={`${styles.socialIcon} ${styles.facebookIcon}`}/>
                </li>
            </ul>
        </div>
        <div className={styles['footer-payments']}>
            <img src={Payments} alt="payments" />
        </div>
    </div>
     {showCookie && (
        <div id="cookie-popup">
          <CookiePopup onClose={() => setShowCookie(false)} />
        </div>
      )}
    </footer>
    );
};

export default Footer;